import { EmploymentStatusTypeId } from '../models/employers/enum/employment-status-type-id';
import { DateUtils } from './date-utils';

export class EmploymentHistoryUtils {
  /** Matches the backend's definition of a current employment; the end date is the last day worked. */
  static isCurrentEmployment(employmentStatusId: EmploymentStatusTypeId, endDate: string | null): boolean {
    if (employmentStatusId !== EmploymentStatusTypeId.Active) {
      return false;
    }
    return !endDate || endDate.slice(0, 10) >= DateUtils.todayInCST();
  }
}
